import { AUTH_CONFIG } from '@src/config/config';
import { useEffect } from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { logAuthEvent } from '@src/service/apiTelemetry';

/** Base64URL (no padding) encode utility */
function base64UrlEncode(bytes: Uint8Array) {
  let str = btoa(String.fromCharCode(...bytes));
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+/g, '');
}

const REDIRECT_URI = config('SSO_REDIRECT_URI') ?? '';

/** Create PKCE codes: code_verifier (43–128 chars) and S256 code_challenge */
async function createPkce() {
  const random = new Uint8Array(48);
  crypto.getRandomValues(random);
  const verifier = base64UrlEncode(random);

  const enc = new TextEncoder();
  const digest = await crypto.subtle.digest('SHA-256', enc.encode(verifier));
  const challenge = base64UrlEncode(new Uint8Array(digest));

  sessionStorage.setItem('pkce_verifier', verifier);
  return { verifier, challenge };
}

export const SSORedirect = () => {
  useEffect(() => {
    (async () => {
      const { challenge } = await createPkce();

      const params = new URLSearchParams({
        client_id: AUTH_CONFIG.clientId,
        response_type: 'code',
        redirect_uri: REDIRECT_URI,
        scope: AUTH_CONFIG.scopes.join(' '),
        code_challenge: challenge,
        code_challenge_method: 'S256',
      });

      const authorizeUrl = `${AUTH_CONFIG.authorizeUrl}?${params.toString()}`;
      logAuthEvent('SSO redirect started', 'pending');
      window.location.href = authorizeUrl;
    })();
  }, []);

  return <><LoadingOverlay
          loadingTitle="Please Wait"
          loadingMessage="Attempting to sign in"
          ariaLoadingLabel="Attempting to sign in"
          isLoading={true}
        >
          <div style={{ height: '100vh' }} />
        </LoadingOverlay></>;
};
